import { render } from "./StoreRetributionsPodium.vue?vue&type=template&id=10876ebd"
import script from "./StoreRetributionsPodium.vue?vue&type=script&lang=js"
export * from "./StoreRetributionsPodium.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__